import React from 'react'

const SentimentViewResult = ({result}) => {
  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr className="bg-base-200">
            <th className="font-bold">Type</th>
            <th className="font-bold">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Value</td>
            <td className="capitalize">{result?.sentiment?.value || '-'}</td>
          </tr>
          <tr>
            <td>Intensity</td>
            <td className="capitalize">{result?.sentiment?.intensity || '-'}</td>
          </tr>
          <tr>
            <td>Confidence</td>
            <td>{result?.sentiment?.confidence ? `${(result?.sentiment?.confidence)}%` : '-'}</td>
          </tr>
          <tr>
            <td>Primary Indicators</td>
            <td>{result?.sentiment?.primary_indicators?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Context Type</td>
            <td className="capitalize">{result?.context?.type || '-'}</td>
          </tr>
          <tr>
            <td>Context Domain</td>
            <td className="capitalize">{result?.context?.domain || '-'}</td>
          </tr>
          <tr>
            <td>Key Phrases</td>
            <td>{result?.context?.key_phrases?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Detected Patterns</td>
            <td>{result?.context?.detected_patterns?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Analysis Tone</td>
            <td className="capitalize">{result?.analysis?.tone || '-'}</td>
          </tr>
          <tr>
            <td>Key Terms</td>
            <td>{result?.analysis?.key_terms?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Confidence Factors</td>
            <td>{result?.analysis?.confidence_factors?.join(', ') || '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default SentimentViewResult
